import { Company } from '@/types'
import { Star } from 'lucide-react'
import { CldImage } from 'next-cloudinary'
import React from 'react'

const ExperienceOrganizer = ({ company }: { company: Company }) => {
  return (
    <div className="flex items-start space-x-4">
      <CldImage
        src={company.logo}
        width="96"
        height="96"
        className="rounded-md"
        alt={`logo of ${company.name}`}
      />

      <div>
        <strong>{company.name}</strong>

        {company.rate ? (
          <div className="flex items-center">
            <Star fill="#004125" size={14} strokeWidth={0} />
            <span className="text-sm">{company.rate}/5</span>
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default ExperienceOrganizer
